import { render, staticRenderFns } from "./Ripple-effect-2.vue?vue&type=template&id=75f3ba7a"
import script from "./Ripple-effect-2.vue?vue&type=script&lang=js"
export * from "./Ripple-effect-2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports